import {
  RemoveRoleSupervisorDocument,
  RemoveRoleSupervisorMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useRemoveRoleSupervisor = () => {
  const [mutate] = useMutation(RemoveRoleSupervisorDocument, {
    extractorFn: (data: RemoveRoleSupervisorMutation) =>
      data.jobCatalogMutations.removeSupervisorJobcatalogRole,
  })

  const removeRoleSupervisor = (id: number, supervisorId: number) => {
    return mutate({ variables: { id, supervisorId } })
  }

  return removeRoleSupervisor
}

export default useRemoveRoleSupervisor
